import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatRadioChange, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-setting',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SettingComponent),
      multi: true,
    },
  ],
  templateUrl: './setting.component.html',
  imports: [MatLabel, MatRadioGroup, MatRadioButton, TranslatePipe],
})
export class SettingComponent implements ControlValueAccessor {
  @Input() settingName: string;
  @Input() value: string;
  private onChange: Function;
  private onTouched: Function;
  isDisabled: boolean;

  constructor() {
    this.onChange = (_: Function) => {};
    this.onTouched = () => {};
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  setValue(event: MatRadioChange) {
    this.value = (event as MatRadioChange).value as string;
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(obj: string): void {
    this.value = obj;
  }

  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }
}
